import { Button } from "components/common/buttons/Button";
import { WorkspaceLoadErrorProps } from "./WorkspaceLoadError.types";

export const WorkspaceLoadError = ({ className, onRetry, message }: WorkspaceLoadErrorProps) => (
  <div className={`text-center py-8 ${className ?? ""}`}>
    <div className="text-muted-foreground text-sm mb-2">Unable to load workspace</div>
    <div className="text-muted-foreground/70 text-xs mb-4">{message ?? "Please try again."}</div>
    {onRetry ? (
      <Button size="sm" onClick={onRetry} className="w-full">
        Retry
      </Button>
    ) : null}
  </div>
);
